export default __webpack_public_path__ + "static/media/ImgTSR.620d0ad3.png";